import {CheckCircle2, Clock, ShieldQuestion, XCircle} from 'lucide-react'
import type { AuditResult } from '@/lib/types'

interface Props {
  audit: AuditResult | null
  size?: 'sm' | 'md'
}

function AuditBadge({ audit, size = 'sm' }: Props) {
  const pad = size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm'

  if (!audit) {
    return (
      <span
        className={`inline-flex items-center gap-1.5 rounded-md ${pad} font-medium`}
        style={{ background: 'rgba(90,106,130,0.14)', color: '#5a6a82', border: '1px solid rgba(90,106,130,0.3)' }}
      >
        <ShieldQuestion className="w-3.5 h-3.5" />
        Unaudited
      </span>
    )
  }

  if (audit.status !== 'completed') {
    return (
      <span
        className={`inline-flex items-center gap-1.5 rounded-md ${pad} font-medium`}
        style={{ background: 'rgba(26,214,196,0.14)', color: '#1ad6c4', border: '1px solid rgba(26,214,196,0.35)' }}
      >
        <Clock className="w-3.5 h-3.5" />
        {audit.status === 'in_review' ? 'In Review' : 'Pending'}
      </span>
    )
  }

  const passed = audit.verdict === 'passed'
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md ${pad} font-medium`}
      style={
        passed
          ? { background: 'rgba(21,190,83,0.14)', color: '#3ee07a', border: '1px solid rgba(21,190,83,0.35)' }
          : { background: 'rgba(255,84,112,0.12)', color: '#ff5470', border: '1px solid rgba(255,84,112,0.35)' }
      }
    >
      {passed ? <CheckCircle2 className="w-3.5 h-3.5" /> : <XCircle className="w-3.5 h-3.5" />}
      {passed ? 'Audit Passed' : 'Audit Failed'}
    </span>
  )
}

export default AuditBadge
